import { get, post } from "../Config";
import { asDataResponse, getNewApiBaseUrl } from "../newApiFallback";

function newApiGet(url, { params, timeOut } = {}) {
  const baseURL = getNewApiBaseUrl();
  if (!baseURL) {
    console.log("[reward] NEW_API_URL is not configured");
    return Promise.resolve({ data: null });
  }
  return get({ url, params, timeOut, baseURL });
}

function newApiPost(url, { data, timeOut } = {}) {
  const baseURL = getNewApiBaseUrl();
  if (!baseURL) {
    console.log("[reward] NEW_API_URL is not configured");
    return Promise.resolve({ data: null });
  }
  return post({ url, data, timeOut, baseURL });
}

// GET
export function RewardList({ params = { limit: 10, offset: 0 } }) {
  return newApiGet(`/api/koala/v1/reward`, { params });
}
export function RewardView({ rewardId = 0, params }) {
  return newApiGet(`/api/koala/v1/reward/${rewardId}`, { params });
}

export function RewardHistoryList({ params }) {
  return newApiGet(`/api/koala/v1/rewardHistory`, { params });
}
export function RewardHistoryView({ rewardHistoryId = 0, params }) {
  return newApiGet(`/api/koala/v1/rewardHistory/${rewardHistoryId}`, { params });
}

export function RewardHistoryWordBookView({ rewardHistoryId = 0, params }) {
  return get({ url: `/api/koala/v1/pillowHistory/${rewardHistoryId}`, params });
}

// POST

export function RewardWordBook({ params }) {
  return get({ url: `/api/koala/v1/reward-wordbook`, params });
}

export function CreateRewardWordBook({ data }) {
  return post({ url: `/api/koala/v1/heartburn-wordbook`, data, timeOut: 20000 });
}

export function CreateReward({ data }) {
  return newApiPost(`/api/koala/v1/redeem`, { data, timeOut: 20000 });
}

export async function CheckPointView() {
  const res = await newApiGet(`/api/me`, { timeOut: 20000 });
  const normalized = asDataResponse(res);
  const pointView = normalized?.data?.resultData?.pointView;
  if (normalized?.data?.resultCode === "20000" && pointView) {
    return {
      data: {
        resultCode: "20000",
        resultDescription: "Success",
        resultData: pointView,
      },
    };
  }
  console.log("[reward] CheckPointView new API >>", normalized?.data ?? res);
  return normalized ?? { data: null };
}
